import nanoid from "nanoid";
import { store } from "../store";
import { getPrevDeviceId } from "../store/selectors/appConfig";

// Get previous device ID or generate a new one
let currentDeviceId;
try {
  const state = store.getState();
  currentDeviceId = state ? getPrevDeviceId(state) : null;
} catch (error) {
  currentDeviceId = null;
}

// Use previous device ID or generate a new one if not available
export const deviceId = currentDeviceId || nanoid();
